import React from "react"
 
 
 
 
import bot from "../imgs/bot.webm"
import botI from "../imgs/bot-10.png"


class NotFoundPage extends React.Component {


  constructor(props) {
    super(props)
    this.state = {
     
      
    }
  }

  componentDidMount() {
    this.setState({
      safari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
    })
  }

  render() {
    return (
      

        <div className="a404-wrapper">
          <div>
            <div className="left">
              <h1>
                Uh oh, are you lost?
                <br />
                (404 Error)
              </h1>
              <p>
                Sometimes you need to get lost before you find your true
                destination.
                <br />
                The link to this address may be outdated or we may have moved
                the page since you last bookmarked it.
              </p>
              <p>
                Return <a href="/">home</a> to start your cyber learning
                journey again.
              </p>
            </div>
            <div className="right">
            {this.state.safari? <img src={botI} name="bot" />:    <video autoPlay="true" loop="true" muted="true" playsinline="true">
                  <source src={bot} type="video/webm" />
                </video>}
             
            </div>
          </div>
        </div>
  
    )
  }
}

export default NotFoundPage
